import * as React from "react";
import Icon from "../Icon/";
import LinkComp from "../LinkComp";
import svgBuyers from "../../svgs/Buyers.svg";
import svgStats from "../../svgs/Stats.svg";
import svgProperties from "../../svgs/Properties.svg";
import svgSellers from "../../svgs/Sellers.svg";
import svgAgents from "../../svgs/Agents.svg";
import svgFirms from "../../svgs/Firms.svg";
import svgTenants from "../../svgs/Tenants.svg";
import svgLenders from "../../svgs/Lenders.svg";
import svgUploads from "../../svgs/Upload.svg";
import svgSignout from "../../svgs/Signout.svg";
import svgExpand from "../../svgs/Expand.svg";
import svgCollapse from "../../svgs/collapse.svg";
import svgStrivePipeline from "../../svgs/StrivePipeline.svg";
import svgAgentPipeline from "../../svgs/AgentPipeline.svg";
import svgBuckets from "../../svgs/Buckets.svg";
import svgInventory from "../../svgs/Inventory.svg";
import svgEscrowTracking from "../../svgs/EscrowTracking.svg";
import svgPipeline from "../../svgs/Pipeline.svg";
import svgStriveFees from "../../svgs/Fees.svg";
import svgHscPipeline from "../../svgs/HscPipeline.svg";
import svgHscTracking from "../../svgs/HSCTracking.svg";
import svgTrainingPages from "../../svgs/TrainingPages.svg";
import plus from '../../svgs/plus-dark.svg';

const getLinks = (isSuper) => {
    return [{
            name: "Properties",
            listPath: "list?SOURCE=STRIVE&STATUS=Active&TRANSACTION_TYPE=Investment+Sales",
            newPath: "property",
            superOnly: false,
            svg: svgProperties,
        }, {
            name: "Sellers",
            listPath: "sellers",
            newPath: "seller",
            superOnly: true,
            svg: svgSellers,
        }, {
            name: "Buyers",
            listPath: isSuper ? "buyers" : "buyers?STATUS=1031-Buyer%2CActive",
            newPath: "buyer",
            superOnly: false,
            svg: svgBuyers,
        }, {
            name: "Agents",
            listPath: "agents",
            newPath: "agent",
            superOnly: true,
            svg: svgAgents,
        }, {
            name: "Firms",
            listPath: "firms",
            newPath: "firm",
            superOnly: true,
            svg: svgFirms,
        }, {
            name: "Tenants",
            listPath: "tenants",
            newPath: "tenant",
            superOnly: true,
            svg: svgTenants,
        }, {
            name: "Lenders",
            listPath: "lenders",
            newPath: "lender",
            superOnly: true,
            svg: svgLenders,
        }, {
            name: "Uploads",
            listPath: "upload-file",
            superOnly: true,
            svg: svgUploads,
        }, {
            name: "Training",
            listPath: "training",
            svg: svgTrainingPages,
        },
    ];
};

const strivePipelineLinks = [{
        url: "agent-pipeline",
        name: "Agent Pipeline",
        svg: svgAgentPipeline,
    }, {
        url: "buckets",
        name: "Buckets",
        svg: svgBuckets,
    }, {
        url: "hsc-pipeline",
        name: "HSC Pipeline",
        svg: svgHscPipeline,
    }, {
        url: "hsc-tracking",
        name: "HSC Tracking",
        svg: svgHscTracking,
    }, {
        url: "inventory",
        name: "Inventory",
        svg: svgInventory,
    }, {
        url: "escrow-tracking",
        name: "Escrow Tracking",
        svg: svgEscrowTracking,
    }, {
        url: "pipeline",
        name: "Pipeline",
        svg: svgPipeline,
    }, {
        url: "strive-fees",
        name: "STRIVE Fees",
        svg: svgStriveFees,
    },
];

export default class Sidebar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            isOpenStrivePipeline: false,
        };
        this.setState = this.setState.bind(this);
        this.handleCollapse = this.handleCollapse.bind(this);
        this.handleCollapseStrivePipeline = this.handleCollapseStrivePipeline.bind(this);
        this.onLinkHover = this.onLinkHover.bind(this);
    }

    handleCollapse() {
        this.setState((prevState) => ({isOpen: !prevState.isOpen}));
    }

    handleCollapseStrivePipeline() {
        this.setState((prevState) => ({
            isOpenStrivePipeline: !prevState.isOpenStrivePipeline,
        }));
    }

    onLinkHover(e) {
        if (!this.state.isOpen) {
            let menuItem = e.currentTarget;
            let wrapper = menuItem.querySelector("div");
            let tooltip = wrapper.children[1];
            tooltip.style.top = menuItem.getBoundingClientRect().top + "px";
        }
    }

    render() {
        const {signOut, pathname, isSuper} = this.props;
        const links = getLinks(isSuper);
        const {isOpen} = this.state;
        const path = pathname.includes('/') ? pathname.split('/')[1] : pathname;

        return signOut ?
            (<div className="Body-wrapper">
                <div className={`Sidebar ${isOpen ? "open" : "closed"}`}>
                    <ul className="Sidebar_list">
                        <li className="Sidebar_item first">
                            <div className="item-wrapper">
                                <div className="Sidebar_item_link" onClick={this.handleCollapse}>
                                    <Icon svg={isOpen ? svgCollapse : svgExpand}/>
                                    <div className="Sidebar_item_link_name">Collapse menu</div>
                                </div>
                                {isOpen ? null : <span className="tooltip">Expand menu</span>}
                            </div>
                        </li>
                        <li className="Sidebar_item" onMouseOver={this.onLinkHover}>
                            <div className="item-wrapper">
                                <LinkComp className={"Sidebar_item_link" + (arc.path.base === pathname ? " Sidebar_item_link--active" : "")}
                                          to={arc.path.base}>
                                    <Icon svg={svgStats}/>
                                    <div className="Sidebar_item_link_name">Stats</div>
                                </LinkComp>
                                {isOpen ? null : <span className="tooltip">Stats</span>}
                            </div>
                        </li>
                        {isSuper
                            ? links.map((x, i) => (
                                <li className={`Sidebar_item ${i === links.length - 1 ? "last" : ""}`}
                                    key={i}
                                    onMouseOver={this.onLinkHover}>
                                    <div className="item-wrapper">
                                        <LinkComp className={`Sidebar_item_link ${isOpen ? "" : "closed-sidebar"}` +
                                                    ([x.listPath.includes('?') ? x.listPath.split('?')[0] : x.listPath, x.newPath].includes(path)
                                                        ? " Sidebar_item_link--active" : "")}
                                                  to={arc.path.base + x.listPath}>
                                            <Icon svg={x.svg}/>
                                            <div className="Sidebar_item_link_name">{x.name}</div>
                                        </LinkComp>
                                        {isOpen ? null : (<span className="tooltip">{x.name}</span>)}
                                        {x.newPath &&
                                            <LinkComp className="New-button"
                                                      to={arc.path.base + x.newPath}>
                                                <Icon svg={plus}/>
                                            </LinkComp>
                                        }
                                    </div>
                                </li>
                            ))
                            : links.map((x, i) => {
                                if (!x.superOnly) {
                                    return (
                                        <li className={`Sidebar_item ${i === links.length - 1 ? "last" : ""}`}
                                            key={i}
                                            onMouseOver={this.onLinkHover}>
                                            <div className="item-wrapper">
                                                <LinkComp
                                                    className={`Sidebar_item_link ${isOpen ? "" : "closed-sidebar"}` +
                                                        ([x.listPath.includes('?') ? x.listPath.split('?')[0] : x.listPath, x.newPath].includes(path)
                                                            ? " Sidebar_item_link--active" : "")}
                                                    to={arc.path.base + x.listPath}>
                                                    <Icon svg={x.svg}/>
                                                    <div className="Sidebar_item_link_name">
                                                        {x.name}
                                                    </div>
                                                </LinkComp>
                                                {isOpen ? null : (<span className="tooltip">{x.name}</span>)}
                                            </div>
                                        </li>
                                    );
                                }
                            })}
                        <li className={`Sidebar_item strive-pipeline first-strive-pipeline ${this.state.isOpenStrivePipeline ? "" : "closed-first-strive-pipeline"}`}
                            onMouseOver={this.onLinkHover}>
                            <div className="item-wrapper">
                                <div className={`Sidebar_item_link ${strivePipelineLinks.find((el) => el.url === path) ? "Sidebar_item_link--active" : ""}`}
                                     onClick={this.handleCollapseStrivePipeline}>
                                    <Icon svg={svgStrivePipeline}/>
                                    <div className="Sidebar_item_link_name">STRIVE PIPELINE</div>
                                </div>
                                {isOpen ? null : (<span className="tooltip">STRIVE Pipeline</span>)}
                            </div>
                        </li>
                        {strivePipelineLinks.map((link, index) => (
                            <li className={`Sidebar_item strive-pipeline ${index === strivePipelineLinks.length - 1 ? "last-strive-pipeline" : ""} ${this.state.isOpenStrivePipeline ? "" : "closed-strive-pipeline"}`}
                                key={index}
                                onMouseOver={this.onLinkHover}>
                                <div className="item-wrapper">
                                    <LinkComp className={`Sidebar_item_link ${isOpen ? "" : "closed-sidebar"}` +
                                                (link.url === path ? " Sidebar_item_link--active" : "")}
                                              to={arc.path.base + link.url}>
                                        <Icon svg={link.svg}/>
                                        <div className="Sidebar_item_link_name">{link.name}</div>
                                    </LinkComp>
                                    {isOpen ? null : <span className="tooltip">{link.name}</span>}
                                </div>
                            </li>
                        ))}
                        <li className="Sidebar_item signout">
                            <div className="item-wrapper">
                                <LinkComp className="Sidebar_item_link"
                                          to={arc.path.base}
                                          onClick={signOut}>
                                    <Icon svg={svgSignout}/>
                                    <div className="Sidebar_item_link_name">Sign out</div>
                                </LinkComp>
                                {isOpen ? null : <span className="tooltip">Sign out</span>}
                            </div>
                        </li>
                    </ul>
                </div>
                <div className={`Body-wrapper_content ${isOpen ? "wrapper-open" : "wrapper-closed"}`}>
                    {this.props.children}
                </div>
            </div>)
            :
            (this.props.children);
    }
}
